import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=0f1574a2&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"
import style0 from "./Training.vue?vue&type=style&index=0&id=0f1574a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1574a2",
  null
  
)

export default component.exports